import { Pipe, PipeTransform } from '@angular/core';


@Pipe({
    name: 'mapRoleNames',
    standalone: false
})
export class MapRoleNamesPipe implements PipeTransform {

  transform(value: any, ...args: unknown[]): unknown {
    return value.map(role => role.name).join(', ');
  }

}
